// src/components/ProductCard.js
import React, { useEffect } from "react";

export default function ProductCard({ product }) {
  useEffect(() => {
    // this will print the resolved path or undefined — useful for debugging
    // check the browser console after page load
    // eslint-disable-next-line no-console
    console.log("Product image:", product.name, product.img);
  }, [product]);

  return (
    <div className="border rounded p-4 hover:shadow-lg transition">
      <div className="w-full h-48 bg-gray-100 flex items-center justify-center overflow-hidden rounded">
        {/* If product.img is undefined the browser will show broken image — console will help */}
        <img
          src={product.img}
          alt={product.name || ""}
          className="w-full h-full object-cover"
        />
      </div>

      <h3 className="font-bold mt-3">{product.name}</h3>
      <p className="text-gray-600">${product.price}</p>
    </div>
  );
}
